module.exports = __webpack_public_path__ + "static/media/chip-4.4e7f2f06.jpg";